import React from 'react'
import { FlatButton, useModalContext } from '@sketch/components'
import { ConfirmRemoveMemberModal } from '../../components/RemoveMemberModal'
import { ProjectFragment, useLeaveProjectMutation } from '@sketch/gql-types'
import { useFolderTerm } from '@sketch/modules-common'

interface LeaveProjectButtonProps {
  project: Pick<ProjectFragment, 'identifier' | 'name'>
  workspaceIdentifier: string
}

export const LeaveProjectButton: React.FC<LeaveProjectButtonProps> = ({
  project,
  workspaceIdentifier,
}) => {
  const { showModal, hideModal } = useModalContext()
  const [leaveProject] = useLeaveProjectMutation({
    variables: { projectIdentifier: project.identifier },
    onError() {
      // onError is used in `<RemoveMemberButton .../>` to handle the case
      // where a user is removing themselves we must show them the confirmation
      // dialog first. All other errors are ignored there.
      //
      // Since we are showing the confirmation dialog in all circumstances (and
      // providing `confirmed: true`) it is not necessary to handle this error
      // case.
      return
    },
  })

  const onConfirm = async () => {
    await leaveProject()
    hideModal()
  }

  const folderTerm = useFolderTerm()

  return (
    <FlatButton
      variant="negative"
      onClick={() =>
        showModal(ConfirmRemoveMemberModal, {
          workspaceIdentifier,
          projectName: project.name,
          projectIdentifier: project.identifier,
          onConfirm,
          onCancelAction: hideModal,
        })
      }
    >
      Leave {folderTerm.upper}&hellip;
    </FlatButton>
  )
}
